import { Component, computed, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

let uniqueIdCounter = 0;

@Component({
  selector: 'app-progress',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './progress.component.html',
  styles: ``,
})
export class ProgressComponent {
  id = signal(`uid-${++uniqueIdCounter}`);
  hasLabel = input(false);
  percentage = input(0); // any value from 0–100
  boxSize = input(96);
  strokeWidth = input(4);
  hasBackground = input(true);
  radius = computed(() => this.boxSize() / 2 - this.strokeWidth() / 2);
  center = computed(() => this.boxSize() / 2);

  translateX = 108;
  translateY = 52;
  circumference = computed(() => 2 * Math.PI * this.radius());

  dashOffset = computed(() => this.circumference() * (1 - this.percentage() / 100));
  readonly gradientStops = computed(() => {
    const percent = this.percentage();
    if (percent < 100) {
      return [
        { offset: '58.75%', color: '#00B7DF' },
        { offset: '100%', color: '#FFA800' },
      ];
    } else {
      return [
        { offset: '0%', color: '#00B7DF' },
        { offset: '100%', color: '#00B7DF' },
      ];
    }
  });
}
